export const GroupResources = {
  path: '/group-resources',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'groupResources',
      component: () => import('pages/groupResources/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.groupResources.name',
        path: '/group-resources',
      },
    },
    {
      path: 'search',
      name: 'groupResources-search',
      component: () => import('pages/groupResources/SearchPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.search',
        parents: [
          {
            title: 'page.groupResources.name',
            path: '/group-resources',
          },
        ],
      },
    },
    {
      path: 'no-group',
      name: 'groupResources-noGroup',
      component: () => import('pages/groupResources/noGroup/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.groupResources.noGroup.name',
        parents: [
          {
            title: 'page.groupResources.name',
            path: '/group-resources',
          },
        ],
      },
    },
    {
      path: 'group-type/:id',
      name: 'groupResources-groupType-id',
      component: () =>
        import('pages/groupResources/groupType/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.groupTypes.name',
        parents: [
          {
            title: 'page.groupResources.name',
            path: '/group-resources',
          },
        ],
      },
    },
    {
      path: 'group-type/:id/edit',
      name: 'groupResources-groupType-id-edit',
      component: () => import('pages/groupResources/groupType/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.groupTypes.name',
        parents: [
          {
            title: 'page.groupResources.name',
            path: '/group-resources',
          },
        ],
      },
    },
    {
      path: 'group/:id',
      name: 'groupResources-group-id',
      component: () => import('pages/groupResources/group/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.groups.name',
        parents: [
          {
            title: 'page.groupResources.name',
            path: '/group-resources',
          },
        ],
      },
    },
    {
      path: 'group/:id/edit',
      name: 'groupResources-group-id-edit',
      component: () => import('pages/groupResources/group/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.groups.name',
        parents: [
          {
            title: 'page.groupResources.name',
            path: '/group-resources',
          },
        ],
      },
    },
    {
      path: 'resource/:id',
      name: 'groupResources-resource-id',
      component: () => import('pages/groupResources/resource/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.resources.name',
        parents: [
          {
            title: 'page.groupResources.name',
            path: '/group-resources',
          },
        ],
      },
    },
    {
      path: 'resource/:id/edit',
      name: 'groupResources-resource-id-edit',
      component: () => import('pages/groupResources/resource/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.resources.name',
        parents: [
          {
            title: 'page.groupResources.name',
            path: '/group-resources',
          },
        ],
      },
    },
  ],
};
